import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useMemo, useState } from "react";
import { useProductsDynamicData, } from "../../hooks/useEssentialProductData/useEssentialProductData";
export const ProductCardContainerContext = createContext({
    products: {},
    productsSkus: {},
});
export const ProductCardContainerContextProvider = ({ children }) => {
    const [productsSkus, setProductsSkus] = useState({});
    const { products, currency, isProductsDataLoaded } = useProductsDynamicData({
        productsSkus: Object.keys(productsSkus),
    });
    const addToSkuList = useCallback((sku) => {
        setProductsSkus((prev) => ({ ...prev, [sku]: true }));
    }, []);
    const value = useMemo(() => ({ productsSkus, addToSkuList, products, currency, isProductsDataLoading: !isProductsDataLoaded }), [productsSkus, addToSkuList, products, currency, isProductsDataLoaded]);
    return _jsx(ProductCardContainerContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=ProductCardContainerContextProvider.js.map